import { render, staticRenderFns } from "./DeliveredDetails.vue?vue&type=template&id=21958b2d"
import script from "./DeliveredDetails.vue?vue&type=script&lang=js"
export * from "./DeliveredDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports